export const OPF = {
  ООО: 'juridical',
  ИП: 'individual',
  АНО: 'juridical_ano',
}
export const TAX_SYSTEM = {
  USN: 'simple',
}
